import React from 'react';
import {
  makeStyles,
  StepConnector,
  StepLabel,
  withStyles,
} from '@material-ui/core';
import styled from 'styled-components';
import { sanlamBlue } from 'Material-UI/colors';

export const useStepIconStyles = makeStyles({
  root: {
    color: '#C4C9D3',
    display: 'flex',
    height: 22,
    alignItems: 'center',
  },
  active: {
    color: sanlamBlue,
  },
  outerCircle: {
    width: 24,
    height: 24,
    borderRadius: '50%',
    border: '2px solid currentColor',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  innerCircle: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    display: 'flex',
    background: 'currentColor',
    justifyContent: 'center',
    alignItems: 'center',
  },
  Circle: {
    background: ' #fff',
    width: 6,
    height: 6,
    borderRadius: '50%',
  },
  completed: {
    color: sanlamBlue,
    width: 24,
    height: 24,
    borderRadius: '50%',
    border: `2px solid ${sanlamBlue}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export const Connector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 28px)',
    right: 'calc(50% + 28px)',
  },
  active: {
    '& $line': {
      borderColor: sanlamBlue,
    },
  },
  completed: {
    '& $line': {
      borderColor: sanlamBlue,
    },
  },
  line: {
    borderColor: '#C4C9D3',
    borderWidth: 2,
  },
})(StepConnector);

export const StyledStepLabel = styled(({ color, ...otherProps }) => (
  <StepLabel
    {...otherProps}
    classes={{
      label: 'label',
      active: 'active',
      completed: 'completed',
    }}
  />
))`
  & .label {
    color: #9197a3;
    margin-bottom: 0px;
    &.active {
      color: ${(props) => props.color};
    }
    &.completed {
      color: ${(props) => props.color};
    }
  }
`;
